(function () {
  'use strict';

  function initializeMobileMenuScrollLock() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.getAttribute('data-mobile-scroll-lock-initialized') === 'true') return;

    drawer.setAttribute('data-mobile-scroll-lock-initialized', 'true');

    var savedScrollY = null;
    var pendingScrollY = null;
    var scrollLocked = false;
    var releaseFrame = null;

    function getScrollY() {
      return window.scrollY || window.pageYOffset || 0;
    }

    function captureScrollPosition(event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('[data-tg-target="#MenuDrawer"]')
        : null;

      if (trigger) pendingScrollY = getScrollY();
    }

    function blockBackgroundScroll(event) {
      if (event.target && event.target.closest && event.target.closest('#MenuDrawer')) return;
      event.preventDefault();
    }

    function pinPageScroll() {
      if (!scrollLocked || savedScrollY === null || getScrollY() === savedScrollY) return;
      window.scrollTo(0, savedScrollY);
    }

    function releaseIncorrectBodyLock() {
      if (!scrollLocked) return;

      /*
       * The shared Drawer helper locks <body>, but this theme scrolls on <html>.
       * On mobile that body mutation clamps scrollY and pulls the sticky header
       * upward while the drawer is sliding in. Undo it before the next paint and
       * keep the page inert with the input/scroll listeners below instead.
       */
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      pinPageScroll();
    }

    function lockPageScroll() {
      if (scrollLocked) return;

      scrollLocked = true;
      savedScrollY = pendingScrollY !== null ? pendingScrollY : getScrollY();
      pendingScrollY = null;

      window.addEventListener('wheel', blockBackgroundScroll, { passive: false });
      window.addEventListener('touchmove', blockBackgroundScroll, { passive: false });
      window.addEventListener('scroll', pinPageScroll, { passive: true });

      /* show.tg.Drawer fires immediately before the shared helper mutates body. */
      Promise.resolve().then(releaseIncorrectBodyLock);
      releaseFrame = window.requestAnimationFrame(releaseIncorrectBodyLock);
    }

    function unlockPageScroll() {
      if (!scrollLocked) return;

      var restoreScrollY = savedScrollY;
      scrollLocked = false;

      window.removeEventListener('wheel', blockBackgroundScroll);
      window.removeEventListener('touchmove', blockBackgroundScroll);
      window.removeEventListener('scroll', pinPageScroll);

      if (releaseFrame !== null) window.cancelAnimationFrame(releaseFrame);
      releaseFrame = null;
      savedScrollY = null;
      pendingScrollY = null;

      if (restoreScrollY !== null && getScrollY() !== restoreScrollY) {
        window.scrollTo(0, restoreScrollY);
      }
    }

    document.addEventListener('pointerdown', captureScrollPosition, true);
    drawer.addEventListener('show.tg.Drawer', lockPageScroll);
    drawer.addEventListener('hidden.tg.Drawer', unlockPageScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileMenuScrollLock, { once: true });
  } else {
    initializeMobileMenuScrollLock();
  }
})();
